module.exports = __webpack_public_path__ + "img/mobile-3.9bedadfa.jpg";